import { ADMSRDF, DCTERMS, VANN } from '../const/C';
import settings from '../virtuoso/settings';
import ApiUtils from '../virtuoso/ApiUtils';
import LiferayApiUtils from '../liferay/ApiUtils';
import LiferaySettings from '../liferay/settings';
import { DcatCatalogDetailsRequest, AdmsAssetsRequest, AdmsAssetsCountRequest, AdmsThemeTaxonomyRequest, 
    skosConceptInScheme, skosConceptInSchemeBroader, skosConceptInSchemeIdentifier,
    NewAssetInCatalogRequest, 
    DeleteAssetInCatalogRequest,     
    DeleteWikiInAssetRequest, DeleteDistributionInAssetRequest,
    NewWikiInAssetRequest, NewWikiInAssetSimpleRequest,
    NewDistributionInAssetRequest, NewDistributionInAssetSimpleRequest,
    RdfsLabelFirstCharCountRequest, DCTermsDescriptionRequest, AddPropertyInAssetRequest,
    RemovePropertyInAssetRequest, UpdateLiteralPropertyRequest, UpdateObjectPropertyRequest,
    NamedIndividualsRequest, DeleteLiteralValueInPropertyRequest, DeleteLinkValueInPropertyRequest,
    SelectGraphByURIRequest, InsertTripleLiteralRequest,
    NewElementInCatalogRequest, SkosNewConceptSchemeSimpleRequest,
    //Статистика таксономии
    SkosConceptLinkCountRequest, SkosConceptsLinkCountRequest,
    //Получение свойств
    PredicatSubjectRequest, PredicatSubjectFilterRequest, RdfsLabelRequest, DcTermsTitleRequest,
    //Список неподключенный активов
    AdmsUnLinkAssetsRequest, AdmsUnLinkAssetsCountRequest, 
    //Убрать и установить связать с каталогом
    UnlinkAssetInCatalogRequest, LinkAssetInCatalogRequest, AdmsAssetBrifInfoRequest,
    //Специальный метод обновления графа в каталоге
    UpdateGraphIriInAllRequest,
    //Методы включения и исключения каточек из каталога
    SksaIncludeAssetsRequest, SksaExcludeAssetsRequest,
    //Методы экпорта/иморта карточке
    ExportAssetRequest,
    //Получение информации о каталогах
    SksaCatalogsRequest, SksaCatalogsCountRequest, SksaElementCatalogsCountRequest,
    VocabsCountRequest, GraphMitCatalogRequest, GraphCatalogInGraphCountRequest,
    //Удаление
    DeleteSubjectRequest, DeleteObjectRequest } from '../virtuoso/request';
import { makeWhereFilter, makeWhereFilterAdv } from '../virtuoso/filter';
import { getCountValue2 } from '../virtuoso/helper';
import { PromiseSequenceRunner } from '../utils/promiseUtil';
import { dispatch } from 'd3';
//import { dispatch } from 'd3';


/** Проверяет, что есть назначенный условия */
const isConditionPresent = (conditions, rfilter) => {
    return (Array.isArray(conditions) && conditions.length>0) || (Array.isArray(rfilter) && rfilter.length>0);
}
/** Формирует запрос с учётом наличия условий. Если условяи есть, то делается cloneOriginal() 
 * и добавляются условия! */
const makeRequest = (pattern, conditions, rfilter) => {
    if (!isConditionPresent(conditions, rfilter))
        return pattern;
    const request = pattern.cloneOriginal();
    makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
    return request;
}

/** Формирует последовательность таксономии. Аналогичная сортировка используется в ConceptSchemes из AssetWidgets.js */
const sortTaxonomy = taxonomy => {
    //Отсортируем sortTaxonomy = taxonomy => {", taxonomy);последовательности IRI в ADMSRDF.TAXONOMY_SEQUENCE
    //console.log("AdmsActions.js sortTaxonomy", taxonomy, ADMSRDF.TAXONOMY_SEQUENCE)
    let j = 0;
    for (let i = 0; i < ADMSRDF.TAXONOMY_SEQUENCE.length; i++) {
        const IRI = ADMSRDF.TAXONOMY_SEQUENCE[i];
        const pos = taxonomy.map(item => item.IRI.value).indexOf(IRI);
        if (pos<0) continue;
        if (j==pos) {j++ ; continue};
        if (j>=(taxonomy.length-1)) break;
        [taxonomy[pos], taxonomy[j]] = [taxonomy[j], taxonomy[pos]];
        j++;
    }
    return taxonomy;
}
//Загрузка описание ADMS каталога (онтологии) и элементов ADMS каталога
export const AdmsRepository = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: "AdmsRepository.EMPTY",
    }),
    SET_RFILTER: rfilter => {
        AdmsRepository.RFILTER = rfilter;
        return ({
            type: "AdmsRepository.SET_RFILTER", 
            rfilter
        })
    },
    LOAD_STARTED: () => ({
        type: "AdmsRepository.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "AdmsRepository.LOAD_ERROR",
        error
    }),
    LOAD_DESCRIPTION: (IRI, description) => ({
        type: "AdmsRepository.LOAD_DESCRIPTION",
        IRI, description
    }),
    LOAD_CATALOG_DETAILS: (iri, head, values) => ({
        type: "AdmsRepository.LOAD_CATALOG_DETAILS",
        iri, values, head,
        predicates : (values && Array.isArray(values))?[...new Set(values.map(item => item.predicat.value))]:[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[]
    }),
    LOAD_ASSETS: (offset, limit, count, head, distinct, ordered, assets) => ({
        type: "AdmsRepository.LOAD_ASSETS",
        offset, limit, count, head, distinct, ordered, assets
    }),
    LOAD_NEXTASSETS: (offset, limit, head, distinct, ordered, assets) => ({
        type: "AdmsRepository.LOAD_NEXTASSETS",
        offset, limit, head, distinct, ordered, assets
    }),
    LOAD_LINKASSETS: (offset, limit, count, head, distinct, ordered, assets) => ({
        type: "AdmsRepository.LOAD_LINKASSETS",
        offset, limit, count, head, distinct, ordered, assets
    }),
    LOAD_NEXTLINKASSETS: (offset, limit, head, distinct, ordered, assets) => ({
        type: "AdmsRepository.LOAD_NEXTLINKASSETS",
        offset, limit, head, distinct, ordered, assets
    }),
    LOAD_THEMETAXONOMY: taxonomy => ({
        type: "AdmsRepository.LOAD_THEMETAXONOMY",
        taxonomy
    }),
    LOAD_TAXONOMY: (taxonomy, concepts, schema, broader, identifier) => ({
        type: "AdmsRepository.LOAD_TAXONOMY",
        taxonomy, concepts, schema, broader, identifier
    }),
    STATISTICS: (IRI, statistic) => ({
        type: "AdmsRepository.STATISTICS", 
        IRI, statistic
    }),
    STATISTICS_BY_THEME: (statistic) => ({
        type: "AdmsRepository.STATISTICS_BY_THEME", 
        statistic
    }),
    STATISTICS_BY_SCHEME: (statistics) => ({
        type: "AdmsRepository.STATISTICS_BY_SCHEME", 
        statistics
    }),
    ADD_ASSET: (iri, label, lang) =>({
        type: "AdmsRepository.ADD_ASSET",
        iri, label, lang
    }),
    LINK_ASSET: (iri, assets) =>({
        type: "AdmsRepository.LINK_ASSET",
        iri, assets
    }),
    REMOVE_ASSET: (iri) => ({
        type: "AdmsRepository.REMOVE_ASSET",
        iri,
    }),
    CONDITIONS: conditions => ({
        type: "AdmsRepository.CONDITIONS",
        conditions,
    }),
    /** Сохранить текущие настройки и выборанные элементы в стеке */
    PUSH : () => ({
        type: "AdmsRepository.PUSH",
    }),

    /** Вернуть текущие настройки и выборанные элементы из стека */
    POP : () => ({
        type: "AdmsRepository.POP",
    }),

    /** Утсановить настройки каталога по умолчнию. 
     * Это может быть публичный каталог или приватный каталог 
     * true - публичный каталог, false - приватный */
    setDefaultCatalog: (publicCatalog=true) => {
        if (publicCatalog){
            settings.catalog.iri = settings.catalog.public;
            settings.catalog.graph.iri = settings.catalog.graph.public;
        }else{
            settings.catalog.iri = settings.catalog.signed;
            settings.catalog.graph.iri = settings.catalog.graph.signed;                        
        };
        UpdateGraphIriInAllRequest(settings.catalog.graph.iri);   
        //console.log("AdmsActions.js setDefaultCatalog", publicCatalog, settings.catalog);
    },

    /** Переключение на публичный каталог */
    swithPublicCatalog: () => dispatch => {
        return dispatch(
            AdmsRepository.swithCatalog(
                settings.catalog.public, 
                settings.catalog.graph.public
            )
        );
    },

    /** Переключение на каталог доступный авторизованному пользователю */
    swithSignedCatalog: () => dispatch => {
        return dispatch(
            AdmsRepository.swithCatalog(
                settings.catalog.signed, 
                settings.catalog.graph.signed
            )
        );
    },

    /** Переключение на новый каталог */
    swithCatalog: (catalog, graph) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());        
        settings.catalog.iri = catalog;
        settings.catalog.graph.iri = graph;
        UpdateGraphIriInAllRequest(graph);
        //console.log("AdmsActions.js swithCatalog 3", catalog, graph, JSON.stringify(settings.catalog), settings.catalog);
        return PromiseSequenceRunner([ //Promise.all
                () => dispatch(AdmsRepository.EMPTY()),
                //Загрузим описание каталога
                //dispatch(AdmsRepository.loadCatalogDetails(catalog)),
                // //Загрузим таксономию
                // () => dispatch(AdmsRepository.loadThemeTaxonomy()),
                // //Снять обязательный фильтр (если он есть)
                // () => dispatch(AdmsRepository.SET_RFILTER([])),
                // //Загрузить систему языков
                // () => dispatch(SettingsActions.loadLinguisticSystem())
            ]);        
    },

    /** Возвращает JSON с текущими параметрами IRI каталога и graph */
    currentCatalog: () =>{
        return {catalog: settings.catalog.iri, graph: settings.catalog.graph.iri};
    },

    /** Загрузить информацию о каталоге (содержимое dcat:Catalog) */
    loadCatalogDetails: (catalog=settings.catalog.iri) => dispatch => {
        const options = {...settings.options};
        dispatch(AdmsRepository.LOAD_STARTED());
        return ApiUtils.query(DcatCatalogDetailsRequest(catalog), {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_CATALOG_DETAILS(settings.catalog.iri, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об ассетах в список. conditions - условия отбора,  
     * rfilter - обязательные условия отбора. При загрузке дополнительно загружается 
     * количество ассатов*/
    loadAssets: (conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        //console.log("AdmsActions.js loadAssets", JSON.stringify(settings), settings);
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(AdmsAssetsRequest(), conditions, rfilter);
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        //console.log("AdmsActions.js loadAssets: (conditions=[], rfilter=[]) => dispatch => {", request);
        const counter = makeRequest(AdmsAssetsCountRequest(), conditions, rfilter);
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(AdmsRepository.LOAD_ASSETS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации об ассетах */
    loadNextAssets: (offset, conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(AdmsAssetsRequest(), conditions, rfilter);
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_NEXTASSETS(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },


    /** Загрузить информацию о таксономии каталога. Является вспомогательной частью описания каталога.
     * Отслеживать процесс загрузки нет необходимости, так как требуется только для фильтрации в UI. */
    loadThemeTaxonomy: () => dispatch => {
        const options = {...settings.options};
        return ApiUtils.query(AdmsThemeTaxonomyRequest(), {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_THEMETAXONOMY(sortTaxonomy(bindings)));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить статистику количества концептов у СА/нСД связанных с каталогом */
    /* Заполняет vadms.statistics **/
    loadTaxonomyStatistic: (rfilter=AdmsRepository.RFILTER, conditions=[]) => dispatch => {        
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? SkosConceptsLinkCountRequest().cloneOriginal():SkosConceptsLinkCountRequest();
        if (isConditionPresent(conditions, rfilter))
            makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const statistics = {};
                if (Array.isArray(bindings)){
                    bindings.map(item => statistics[item.theme.value] = {"count":item.cnt.value});
                };                
                //Пример ответа { "head": { "link": [], "vars": ["theme", "cnt"] },
                // "results": { "distinct": false, "ordered": true, "bindings": [
                //      { "theme": { "type": "uri", "value": "http://hbz.ru/adms/internal" }, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "7" }} ] } }
                dispatch(AdmsRepository.STATISTICS_BY_THEME(statistics));
                return Promise.resolve({response, statistics});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    /** Загрузка концептов, входящих в схему. */
    loadTaxonomy: taxonomy => dispatch => {
        const options = {...settings.options};
        skosConceptInScheme.setConceptScheme(taxonomy);
        skosConceptInSchemeBroader.setConceptScheme(taxonomy);
        skosConceptInSchemeIdentifier.setConceptScheme(taxonomy);
        RdfsLabelRequest.setURI(taxonomy);
        
        return Promise.all([
                ApiUtils.query(skosConceptInScheme, {}, options),
                ApiUtils.query(RdfsLabelRequest, {}, options),
                ApiUtils.query(skosConceptInSchemeBroader, {}, options),
                ApiUtils.query(skosConceptInSchemeIdentifier, {}, options),
            ]) .then ((response) =>{
                //console.log("AdmsActions.js loadTaxonomy: taxonomy => dispatch =>", response);
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_TAXONOMY(
                    taxonomy, 
                    bindings, 
                    response[1].results.bindings, 
                    response[2].results.bindings.reduce((result, item) => {
                        result[item.IRI.value] = item.broader.value;
                        return result;
                    }, {}),
                    response[3].results.bindings.reduce((result, item) => {
                        result[item.IRI.value] = item.identifier.value;
                        return result;
                    }, {}))
                    );
                const statistics = {};
                if (Array.isArray(bindings)){
                    bindings.map(item => statistics[item.IRI.value] = {"count":0});
                };                
                //console.log("AdmsActions.js loadTaxonomy", response, bindings, statistics);
                dispatch(AdmsRepository.STATISTICS_BY_SCHEME(statistics));
                return Promise.resolve({taxonomy, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    loadTaxonomyConceptCount: (conceptIRI, lang, graph, rfilter=AdmsRepository.RFILTER, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? SkosConceptLinkCountRequest().cloneOriginal():SkosConceptLinkCountRequest();
        request.setConceptIRI(conceptIRI);
        if (isConditionPresent(conditions, rfilter))
            makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        //console.log("loadTaxonomyConceptCount: conceptIRI => dispatch => { SkosConceptLinkCountRequest", SkosConceptLinkCountRequest.request);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const count =(Array.isArray(bindings) && (bindings.length>0))?bindings[0].cnt.value: 0;
                //Пример ответа { "head": { "link": [], "vars": ["theme", "cnt"] },
                // "results": { "distinct": false, "ordered": true, "bindings": [
                //      { "theme": { "type": "uri", "value": "http://hbz.ru/adms/internal" }, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "7" }} ] } }
                dispatch(AdmsRepository.STATISTICS(conceptIRI, {count}));
                return Promise.resolve({conceptIRI, count, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузка количества доступных элементов по таксономии. Заполняет vadms.statistics */
    loadFirstCharCount: (lang, graph, rfilter=AdmsRepository.RFILTER, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = (isConditionPresent(conditions, rfilter))? RdfsLabelFirstCharCountRequest().cloneOriginal():RdfsLabelFirstCharCountRequest();
        //Убераем добавления фильтра, так как алфавит работает схеме ИЛИ, т.е. нужно всегда знать все доступные буквы
        //2025 июня 09 по требованию статкомитета добавляем проверку и
        if (isConditionPresent(conditions, rfilter))
            makeWhereFilterAdv(request, [...conditions.map(a => ({...a})), ...rfilter.map(a => ({...a}))], true);
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                //Пример ответа { "head": { "link": [], "vars": ["firstlitera", "cnt"] },
                //"results": { "distinct": false, "ordered": true, "bindings": [
                //  { "firstlitera": { "type": "literal", "value": "F" }	, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "1" }},
                //  { "firstlitera": { "type": "literal", "value": "\u0422" }	, "cnt": { "type": "typed-literal", "datatype": "http://www.w3.org/2001/XMLSchema#integer", "value": "1" }} ] } }
                const chars = {};
                bindings.map(item => chars[item["firstlitera"].value]=item["cnt"].value);
                dispatch(AdmsRepository.STATISTICS("http://www.w3.org/2000/01/rdf-schema#label", {chars}));
                return Promise.resolve({IRI:"http://www.w3.org/2000/01/rdf-schema#label", chars, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    addElement: (catalog, iri, type, label, lang) => dispatch => {
        NewAssetInCatalogRequest.setValues(catalog, iri, type, label, lang);
        //const options = {...settings.options};
        //console.log("NewAssetInCatalogRequest",NewAssetInCatalogRequest.request);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
          'default_graph_uri': NewAssetInCatalogRequest.graph,
          'query': NewAssetInCatalogRequest.sparql,
        }
        //console.log("AdmsActions.js addElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
          .then ((response) =>{
                dispatch(AdmsRepository.ADD_ASSET(iri, label, lang));
                return Promise.resolve({iri, type, label, lang, response});
          })
          .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
          });
    },

    /** Добавление нового элемента. Для добавления используется прокси сервис в Liferay */
    deleteElement: (catalog, iri) => dispatch => {
        DeleteAssetInCatalogRequest.setCatalog(catalog);
        DeleteAssetInCatalogRequest.setIRI(iri);
        //const options = {...settings.options};
        //console.log("DeleteAssetInCatalogRequest",DeleteAssetInCatalogRequest.request);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteAssetInCatalogRequest.graph,
            'query': DeleteAssetInCatalogRequest.sparql,
          }
        //console.log("AdmsActions.js deleteElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsRepository.REMOVE_ASSET(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });

        //   return ApiUtils.query(DeleteAssetInCatalogRequest, {}, options)
        //     .then ((response) =>{
        //         dispatch(AdmsRepository.REMOVE_ASSET(iri));
        //         return Promise.resolve({iri, response});
        //     })
        //     .catch(e => { 
        //         dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
        //         return Promise.reject(e);
        //     });
    },

    /** Удаление связи. Для удаления связи используется прокси сервис в Liferay */
    unlinkElement: (catalog, iri) => dispatch => {
        UnlinkAssetInCatalogRequest.setCatalog(catalog);
        UnlinkAssetInCatalogRequest.setIRI(iri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UnlinkAssetInCatalogRequest.graph,
            'query': UnlinkAssetInCatalogRequest.sparql,
          }
        AdmsAssetBrifInfoRequest
        //console.log("AdmsActions.js unlinkElement", formData, options);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsRepository.REMOVE_ASSET(iri));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию об описаниии актива. Значение для предиката http://purl.org/dc/terms/description  */
    loadDescription: (iri) => dispatch => {
        const options = {...settings.options};
        DCTermsDescriptionRequest.setURI(iri);
        return ApiUtils.query(DCTermsDescriptionRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsRepository.LOAD_DESCRIPTION(iri, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление новой схемы концептов (классификатора для каталога) */
    addSkosConceptSchemeSimple: (iri, label, lang) => dispatch => {
        const options = {...settings.options};
        SkosNewConceptSchemeSimpleRequest.setValues(iri, label, lang);;
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': SkosNewConceptSchemeSimpleRequest.graph,
            'query': SkosNewConceptSchemeSimpleRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //dispatch(AdmsAsset.ADD_WIKI(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление новой схемы концептов (классификатора для каталога) */
    addElementSimple: (iri, type, label, lang) => dispatch => {
        const options = {...settings.options};
        NewElementInCatalogRequest.setValues(iri, label, lang);;
        NewElementInCatalogRequest.setType(type);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewElementInCatalogRequest.graph,
            'query': NewElementInCatalogRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //dispatch(AdmsAsset.ADD_WIKI(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },
    
    /** Загрузить информацию об ассетах НЕ включённых в список. conditions - условия отбора,  
     * rfilter - обязательные условия отбора. При загрузке дополнительно загружается 
     * количество ассетов*/
    loadUnLinkAssets: (conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(AdmsUnLinkAssetsRequest(), conditions, rfilter);
        request.request.offset = 0;
        request.request.limit = 1000;
        const counter = makeRequest(AdmsUnLinkAssetsCountRequest(), conditions, rfilter);
        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(AdmsRepository.LOAD_LINKASSETS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Установка связи. Для установки связи используется прокси сервис в Liferay. 
     * После установки необходимо получить информацию об активе
    */
    linkAsset: (catalog, asset) => dispatch => {
        LinkAssetInCatalogRequest.setValue(catalog, asset);
        const updateOptions = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': LinkAssetInCatalogRequest.graph,
            'query': LinkAssetInCatalogRequest.sparql,
          }
        const request = AdmsAssetBrifInfoRequest(catalog);
        //console.log("AdmsActions.js linkAsset", catalog, asset, request);
        request.setAsset(asset);
        const options = {...settings.options};
        return Promise.all([
                LiferayApiUtils.postToLifeRay721(formData, updateOptions),
                ApiUtils.query(request, {}, options)                
            ]) .then (response =>{
                //console.log("AdmsActions.js linkAsset", catalog, asset, response);
                dispatch(AdmsRepository.LINK_ASSET(asset, response[1].results.bindings));
                return Promise.resolve({asset, response});
            })
            .catch(e => { 
                dispatch(AdmsRepository.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    includeAssetsInCatalog: (catalog, graph, conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());        
        const options = {...settings.options};
        const request = makeRequest(SksaIncludeAssetsRequest(), conditions, rfilter);
        console.log("AdmsActions.js includeAssetsInCatalog", catalog, request, request.sparql);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({catalog, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    excludeAssetsFromCatalog:(catalog, graph, conditions=[], rfilter=AdmsRepository.RFILTER) => dispatch => {
        dispatch(AdmsRepository.LOAD_STARTED());
        const options = {...settings.options};
        const request = makeRequest(SksaExcludeAssetsRequest(), conditions, rfilter);
        //console.log("AdmsActions.js onExcludeFromCatalog", catalog, request, request.sparql);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({catalog, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    importAssetInCatalog: (graph, sparql) => {
        const options = {...settings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': graph,
            'query': sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },
};

/** 
 * Сформировать описание распространение в redux adms. Выделяются элементы в ответе 
 * имеющие предикат ADMSRDF.PREDICAT_DISTRIBUTION
*/
const makeDistributions = (values) => {
    //console.log("AdmsActions.js const makeDistributions = (values)", values);
    const distributions = (values && Array.isArray(values))? values.filter(item => item.predicat.value== ADMSRDF.PREDICAT_DISTRIBUTION):[];
    distributions.forEach(distribution => {
        distribution["iri"]= distribution.object.value;
    });
    //console.log("AdmsActions.js const makeDistributions = (values)", distributions);
    return distributions;
}

/**
 * Сформировать возможные значения IRI графов в Virtuoso.
 * Могут быть IRI карточки в конце #, значение поля dcterms:identifier, значение поля vann:preferredNamespaceUri
 */
const makeGraphContent = (iri, values) => {
    //console.log("AdmsActions.js makeGraphContent = (iri, values)", iri, values);
    const graphs = (iri.lastIndexOf('#')>0)?[iri+'Graph']:[iri+'#']
    if (values && Array.isArray(values)){
        const ids = values.filter(item => item.predicat.value== DCTERMS.IDENTIFIER);
        ids.forEach(uri => {
            if (uri.object.value.startsWith("http")){
                graphs.push(uri.object.value);
                if (uri.object.value.lastIndexOf('#')>0)
                    graphs.push(uri.object.value+'Graph');
                else
                    graphs.push(uri.object.value+'#');
            }
        });
        const ns = values.filter(item => item.predicat.value== VANN.PREFERREDNAMESPACEURI);
        ns.forEach(uri =>{            
            graphs.push(uri.object.value);
        });
    }
    return graphs.map(uri =>  { return {'iri': uri, "state": "recommended"}});
}

export const AdmsAsset = {
    EMPTY: () => ({
        type: "AdmsAsset.EMPTY",
    }),
    LOAD_STARTED: () => ({
        type: "AdmsAsset.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "AdmsAsset.LOAD_ERROR",
        error
    }),
    LOAD_ASSET: (iri, head, values) => ({
        type: "AdmsAsset.LOAD_ASSET",
        iri, values, head,
        types: (values && Array.isArray(values))
            ?[...new Set(
                values.filter(item => item.predicat.value == "http://www.w3.org/1999/02/22-rdf-syntax-ns#type")
                      .map(item => item.object.value))
             ]
            :[], 
        predicates : (values && Array.isArray(values))
            ?[...new Set(values.map(item => item.predicat.value))]
            :[], 
        languages: (values && Array.isArray(values))?[...new Set(values.map(item => item.object["xml:lang"]))]:[], 
        distributions: makeDistributions(values), 
        wikies: (values && Array.isArray(values))? values.filter(item => 
            item.predicat.value== ADMSRDF.PREDICAT_WIKI || item.predicat.value== ADMSRDF.SKSA_PREDICAT_WIKI
            ):[], 
        graphs: makeGraphContent(iri, values),
    }),
    LOAD_LABELBYIRI: (iri, head, values) => ({
        type: "AdmsAsset.LOAD_LABELBYIRI",
        iri, values, head,
    }),
    LOAD_TYPESBYIRI: (iri, values) => ({
        type: "AdmsAsset.LOAD_TYPESBYIRI",
        iri, values,
    }),
    LOAD_DISTRIBUTIONS: distributions => ({
        type: "AdmsAsset.LOAD_DISTRIBUTIONS", 
        distributions
    }),

    RELOAD_DISTRIBUTION: (iri, values) => ({
        type: "AdmsAsset.RELOAD_DISTRIBUTION", 
        iri, values
    }),

    LOAD_WIKIES: wikies => ({
        type: "AdmsAsset.LOAD_WIKIES", 
        wikies
    }),

    RELOAD_WIKI: (iri, values) => ({
        type: "AdmsAsset.RELOAD_WIKI", 
        iri, values
    }),

    LOAD_DETAIL: (triplet, head, values, state) => ({
        type: "AdmsAsset.LOAD_DETAIL",
        triplet, head, values, state,
    }),

    REMOVE_DISTRIBUTION: (iri) => ({
        type: "AdmsAsset.REMOVE_DISTRIBUTION",
        iri,
    }),

    ADD_DISTRIBUTION: (iri, distribution) => ({
        type: "AdmsAsset.ADD_DISTRIBUTION",
        iri, distribution
    }),

    REMOVE_WIKI: (iri) => ({
        type: "AdmsAsset.REMOVE_WIKI",
        iri,
    }),

    ADD_WIKI: (iri, wiki) => ({
        type: "AdmsAsset.ADD_WIKI",
        iri, wiki
    }),

    GRAPH_STATE: (iri, state) => ({ type: "AdmsAsset.GRAPH_STATE",iri, state }),

    /** Загрузить информацию ассетах */
    loadAsset: (iri) => dispatch => {
        dispatch(AdmsAsset.LOAD_STARTED());
        const options = {...settings.options};
        //console.log("11111", PredicatSubjectRequest.request);
        PredicatSubjectRequest.setIRI(iri);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_ASSET(iri, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    loadSelected: (iri) => dispatch => {
        return dispatch(AdmsAsset.loadAsset(iri));
    },

    //Загрузить дополнительную информацию о метках (label, title, prefLabel), элементов связанных с СА/нСД
    //Элементы являются объектами в триплетах СА/нСД, где субъектом указан IRI СА/нСД
    //Дополнительно загружается тип связанного элемента
    loadLabels: (IRI) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectFilterRequest.setParams(IRI, 
            ["http://www.w3.org/2000/01/rdf-schema#label",
             "http://purl.org/dc/terms/title",
             "http://www.w3.org/2004/02/skos/core#prefLabel",
             "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
            ]
        );
        return ApiUtils.query(PredicatSubjectFilterRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const labels = results.bindings.filter(
                    row => row.predicat.value != "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                );
                dispatch(AdmsAsset.LOAD_LABELBYIRI(IRI, head, labels));
                const rdfTypes = results.bindings.filter(
                    row => row.predicat.value == "http://www.w3.org/1999/02/22-rdf-syntax-ns#type"
                ).map(
                    item => item.object.value
                );
                dispatch(AdmsAsset.LOAD_TYPESBYIRI(IRI, rdfTypes));
                return Promise.resolve({head, labels});
            })
            .catch(e => { 
                //этот action сбрасывает всю карточку, включая values, predicates, iri
                //dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Загрузить информацию о метках 
    loadLabelByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        RdfsLabelRequest.setURI(IRI);
        return ApiUtils.query(RdfsLabelRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    // Загрузить информацию о заголовках
    loadTitleByIRI: (IRI) => dispatch => {
        const options = {...settings.options};
        DcTermsTitleRequest.setURI(IRI);
        return ApiUtils.query(DcTermsTitleRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_LABELBYIRI(IRI, head, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Получение детальной информации о триплете */
    onDetailElement: (triplet) => dispatch => {
        const options = {...settings.options};
        PredicatSubjectRequest.setIRI(triplet.object.value);
        return ApiUtils.query(PredicatSubjectRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(AdmsAsset.LOAD_DETAIL(triplet, head, bindings, "loaded"));
                return Promise.resolve({triplet, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_DETAIL(triplet, [], [], "error"));
                return Promise.reject(e);
            });
    },

    deleteDistribution: (asset, distribution) => dispatch => {
        const options = {...settings.options};
        DeleteDistributionInAssetRequest.setAsset(asset);
        DeleteDistributionInAssetRequest.setIRI(distribution);        
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteDistributionInAssetRequest.graph,
            'query': DeleteDistributionInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.REMOVE_DISTRIBUTION(distribution));
                return Promise.resolve({distribution, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    deleteWiki: (asset, wiki) => dispatch => {
        const options = {...settings.options};
        DeleteWikiInAssetRequest.setAsset(asset);
        DeleteWikiInAssetRequest.setIRI(wiki);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': DeleteWikiInAssetRequest.graph,
            'query': DeleteWikiInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.REMOVE_WIKI(wiki));
                return Promise.resolve({wiki, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addWiki: (asset, iri, title, description, url, lang) => dispatch => {
        const options = {...settings.options};
        NewWikiInAssetRequest.setAsset(asset);
        NewWikiInAssetRequest.setValues(iri, title, description, url, lang);
        // console.log("AdmsActions.js addWiki", asset, iri, title, url, lang, 
        //     NewWikiInAssetRequest.graph, NewWikiInAssetRequest.sparql, NewWikiInAssetRequest);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewWikiInAssetRequest.graph,
            'query': NewWikiInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("addWiki", asset, iri, title, description, url, lang, response);
                dispatch(AdmsAsset.ADD_WIKI(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addWikiSimple: (asset, iri, title, lang) => dispatch => {
        const options = {...settings.options};
        NewWikiInAssetSimpleRequest.setAsset(asset);
        NewWikiInAssetSimpleRequest.setValues(iri, title, lang);;
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewWikiInAssetSimpleRequest.graph,
            'query': NewWikiInAssetSimpleRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.ADD_WIKI(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Добавление распространения. */
    addDistributionSimple: (asset, iri, title, lang) => dispatch => {
        const options = {...settings.options};
        NewDistributionInAssetSimpleRequest.setAsset(asset);
        NewDistributionInAssetSimpleRequest.setValues(iri, title, lang);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewDistributionInAssetSimpleRequest.graph,
            'query': NewDistributionInAssetSimpleRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                dispatch(AdmsAsset.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addDistribution: (asset, iri, title, description, url, lang) => dispatch => {
        const options = {...settings.options};
        NewDistributionInAssetSimpleRequest.setAsset(asset);
        NewDistributionInAssetRequest.setAsset(asset);
        NewDistributionInAssetRequest.setValues(iri, title, description, url, lang);
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': NewDistributionInAssetRequest.graph,
            'query': NewDistributionInAssetRequest.sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("addDistribution", asset, iri, title, description, url, lang, NewDistributionInAssetRequest.request, response);
                dispatch(AdmsAsset.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    addProperty: (IRI, predicat, lang) => dispatch => {
        AddPropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': AddPropertyInAssetRequest.graph,
            'query': AddPropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("AdmsActions.js addProperty", IRI, predicat, lang, AddPropertyInAssetRequest.request, response);
                //dispatch(AdmsAsset.ADD_DISTRIBUTION(iri, response));
                return Promise.resolve({IRI, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    insertTriple: (subject, predicat, value, lang=undefined) => dispatch => {
        InsertTripleLiteralRequest.setValues(subject, predicat, value, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri':InsertTripleLiteralRequest.graph,
            'query': InsertTripleLiteralRequest.sparql,
          }
        //console.log("AdmsActions.js insertTriple", subject, predicat, value, lang, InsertTripleRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                //console.log("AdmsActions.js insertTriple", subject, predicat, value, lang, InsertTripleRequest.request, response);
                return Promise.resolve({subject, predicat, value, lang});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    removeProperty: (IRI, predicat) => dispatch => {
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        RemovePropertyInAssetRequest.setValues(IRI, predicat);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': RemovePropertyInAssetRequest.graph,
            'query': RemovePropertyInAssetRequest.sparql,
          }
        //console.log("AdmsActions.js removeProperty", IRI, predicat, RemovePropertyInAssetRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({IRI, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    updateLiteralProperty: (IRI, predicat, oldValue, newValue, lang) => dispatch => {
        //console.log("AdmsActions.js updateLiterlProperty", IRI, predicat, oldValue, newValue, lang, UpdateLiteralPropertyRequest);
        UpdateLiteralPropertyRequest.setValues(IRI, predicat, oldValue, newValue, lang);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateLiteralPropertyRequest.graph,
            'query': UpdateLiteralPropertyRequest.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", UpdateLiteralPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

    updateObjectProperty: (IRI, predicat, oldValue, newValue) => dispatch => {
        //console.log("AdmsActions.js updateObjectProperty", IRI, predicat, oldValue, newValue, UpdateObjectPropertyRequest);
        UpdateObjectPropertyRequest.setValues(IRI, predicat, oldValue, newValue);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': UpdateObjectPropertyRequest.graph,
            'query': UpdateObjectPropertyRequest.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", UpdateObjectPropertyRequest);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },
 
    /** Загрузить информацию об индивидуалах. rdfType - IRI типf */
    loadNamedIndividuals: (rdfType, graph) => {
        const options = {...settings.options};
        NamedIndividualsRequest.setType(rdfType);
        return ApiUtils.query(NamedIndividualsRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({rdfType, head, distinct, ordered, bindings});
            })
            .catch(e => { 
                return Promise.reject(e);
            });
    }, 

    deleteValueInProperty: (IRI, predicat, value) => dispatch => {
        const request = (value && value.startsWith("http")) ? DeleteLinkValueInPropertyRequest:DeleteLiteralValueInPropertyRequest;
        //console.log("AdmsActions.js deleteValueInObjectProperty", IRI, predicat,value, request);
        request.setValues(IRI, predicat, value);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': request.graph,
            'query': request.sparql,
          }
        //console.log("AdmsActions.js updateLiterlProperty", request);
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(AdmsAsset.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        //return Promise.reject(e);
    },

    /** Проверка наличия графа в БД Virtuoso. Варианты состояние: present, none, error */
    checkGraphState: (iri) => dispatch => {        
        const options = {...settings.options};
        const request = SelectGraphByURIRequest;
        request.setGraph(iri);
        //console.log("AdmsActions.js checkGraphState", iri, request, request.sparql);
        return ApiUtils.query(SelectGraphByURIRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const state = Array.isArray(bindings) && bindings.length>0 ? "present" : "none";
                dispatch(AdmsAsset.GRAPH_STATE(iri, state));
                return Promise.resolve({iri, state, distinct, ordered, bindings});
            })
            .catch(e => { 
                dispatch(AdmsAsset.GRAPH_STATE(iri, "error"));
                return Promise.reject(e);
            });
     },

    /** Выполнение запроса CONSTRUCT для получения карточки. Граф определяется из запроса */
    exportCard: (graph, IRIs) => {
        ExportAssetRequest.setIRIs(IRIs);
        //console.log("AdmsActions.js exportCard", IRIs, ExportAssetRequest, ExportAssetRequest.sparql);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
          'default_graph_uri': ExportAssetRequest.graph,
          'output_format': 'N-TRIPLE',
          'query': ExportAssetRequest.sparql,
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** Выполнение запроса CONSTRUCT для получения всех данных из графа */
    exportGraph: (graph) => {
        //console.log("AdmsActions.js exportCard", IRIs, ExportAssetRequest, ExportAssetRequest.sparql);
        const options = {...LiferaySettings.options};
        const formData = {
          'cmd': JSON.stringify({'/mpo.mpo/sparql_construct':{}}),
          'default_graph_uri': graph,
          'output_format': 'N-TRIPLE',
          'query': "CONSTRUCT {?s ?p ?o } WHERE {?s ?p ?o }",
        }
        return LiferayApiUtils.postToLifeRay721(formData, options);
    },

    /** Проверка наличия графа в БД Virtuoso (без вызова AdmsAsset.GRAPH_STATE). 
     * Варианты состояние: present, none, error */
    checkGraphState2: (iri) => {
        const options = {...settings.options};
        const request = SelectGraphByURIRequest;
        request.setGraph(iri);
        //console.log("AdmsActions.js checkGraphState2", iri, request, request.sparql);
        return ApiUtils.query(SelectGraphByURIRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                const state = Array.isArray(bindings) && bindings.length>0 ? "present" : "none";
                return Promise.resolve({iri, state, distinct, ordered, bindings});
            })
            .catch(e => { 
                return Promise.reject(e);
            });
     },
}

/** Загрузка списка каталогов */
export const DcatCatalogs = {
    //Значение обязательного фильтра
    RFILTER: [],
    EMPTY: () => ({
        type: "DcatCatalogs.EMPTY",
    }),
    SET_RFILTER: rfilter => {
        DcatCatalogs.RFILTER = rfilter;
        return ({
            type: "DcatCatalogs.SET_RFILTER", 
            rfilter
        })
    },
    CONDITIONS: conditions => ({
        type: "DcatCatalogs.CONDITIONS",
        conditions,
    }),
    LOAD_STARTED: () => ({
        type: "DcatCatalogs.LOAD_STARTED",
    }),
    LOAD_ERROR: (error) => ({
        type: "DcatCatalogs.LOAD_ERROR",
        error
    }),
    GPAPHS: (head, distinct, ordered, graphs) => ({
        type: "DcatCatalogs.GPAPHS",
        head, distinct, ordered, graphs
    }),
    LOAD_CATALOGS: (offset, limit, count, head, distinct, ordered, items) => ({
        type: "DcatCatalogs.LOAD_CATALOGS",
        offset, limit, count, head, distinct, ordered, items
    }),
    LOAD_NEXTCATALOGS: (offset, limit, head, distinct, ordered, items) => ({
        type: "DcatCatalogs.LOAD_NEXTCATALOGS",
        offset, limit, head, distinct, ordered, items
    }),
    /** Сохранить текущие настройки и выборанные элементы в стеке */
    PUSH : () => ({
        type: "DcatCatalogs.PUSH",
    }),

    /** Вернуть текущие настройки и выборанные элементы из стека */
    POP : () => ({
        type: "DcatCatalogs.POP",
    }),

    loadGraphs: () => dispatch => {
        dispatch(DcatCatalogs.LOAD_STARTED());
        const options = {...settings.options};        
        return ApiUtils.query(GraphMitCatalogRequest, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(DcatCatalogs.GPAPHS(head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });

    },

    /** Загрузка клочество элементов dcat:Catalog в графе */
    loadCatalogInGraphCount: (graph, conditions=[]) => dispatch => {
        const options = {...settings.options};
        const request = GraphCatalogInGraphCountRequest.cloneOriginal();        
        request.setGraph(graph)
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const count = getCountValue2(response?.results?.bindings, -1);
                return Promise.resolve({count, response});
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
        
    },

    /** Загрузить информацию о каталогах в список. conditions - условия отбора,  
     * rfilter - обязательные условия отбора. При загрузке дополнительно загружается 
     * количество каталогов*/
    loadCatalogs: (conditions=[], rfilter=DcatCatalogs.RFILTER) => dispatch => {
        console.log("AdmsActions.js loadCatalogs", conditions);
        dispatch(DcatCatalogs.LOAD_STARTED());
        const options = {...settings.options};
        const request = SksaCatalogsRequest.cloneOriginal();
        request.request.offset = 0;
        request.request.limit = settings.defaultLimit;
        const counter = SksaCatalogsCountRequest.cloneOriginal();
        if (Array.isArray(conditions) && conditions.length>0){            
            request.setGraphs(conditions
                .filter(condition => condition.variable === 'graph')
                .map(condition => condition.value));
            counter.setGraphs(conditions
                .filter(condition => condition.variable === 'graph')
                .map(condition => condition.value));
        };

        return Promise.all([
                ApiUtils.query(request, {}, options),
                ApiUtils.query(counter, {}, options),
            ]).then ((response) =>{
                const {head, results} = response[0];
                const {distinct, ordered, bindings} = results;
                const count = getCountValue2(response[1].results.bindings, -1);
                dispatch(DcatCatalogs.LOAD_CATALOGS(0, request.request.limit, count, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить следующую порцию информации о каталогах */
    loadNextCatalogs: (offset, conditions=[], rfilter=DcatCatalogs.RFILTER) => dispatch => {
        dispatch(DcatCatalogs.LOAD_STARTED());
        const options = {...settings.options};
        const request = SksaCatalogsRequest.cloneOriginal();
        if (Array.isArray(conditions) && conditions.length>0)
            request.setGraphs(conditions
                .filter(condition => condition.variable === 'graph')
                .map(condition => condition.value)
            );
        request.request.offset = offset;
        request.request.limit = settings.defaultLimit;
        return ApiUtils.query(request, {}, options)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                dispatch(DcatCatalogs.LOAD_NEXTCATALOGS(offset, request.request.limit, head, distinct, ordered, bindings));
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию о каталоге (содержимое dcat:Catalog) из заданного графа */
    loadCatalogDetails: (catalog, graph) => dispatch => {
        dispatch(DcatCatalogs.LOAD_STARTED());
        return ApiUtils.queryViaLiferay(DcatCatalogDetailsRequest(catalog).sparql, graph)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;                
                return Promise.resolve(response);
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию о каталоге (содержимое dcat:Catalog) из заданного графа */
    loadCatalogCountDetails: (graph, rdfTypes) => dispatch => {
        dispatch(DcatCatalogs.LOAD_STARTED());
        const vCount = VocabsCountRequest.cloneOriginal();
        vCount.setTypes(rdfTypes)
        return Promise.all([
            ApiUtils.queryViaLiferay(SksaElementCatalogsCountRequest.sparql, graph),
            ApiUtils.queryViaLiferay(vCount.sparql, graph),
        ]) .then ((response) =>{
                const bindings = response[0].results.bindings;
                if (Array.isArray(response[1].results?.bindings) && response[1].results.bindings.length>0)
                    bindings[0]["vocabsCount"] = response[1].results.bindings[0]["count"];
                else 
                    bindings[0]["vocabsCount"] = {"value": "0"};
                return Promise.resolve({head: response[0].head, results: {bindings}});
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Get all instances of dcat:Resource and its subclasses. */
    loadResourceIRIs: (graph) => dispatch => {
        const sparql = `SELECT DISTINCT ?resource WHERE {
            ?resource a ?type .
            ?type <http://www.w3.org/2000/01/rdf-schema#subClassOf>*
                  <http://www.w3.org/ns/dcat#Resource> .
        }`;
        return ApiUtils.queryViaLiferay(sparql, graph)
            .then(response => (response.results?.bindings || [])
                .map(item => item.resource?.value).filter(Boolean))
            .catch(e => {
                dispatch(DcatCatalogs.LOAD_ERROR(`Failed to load dcat:Resource instances: ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Удаление элемента. Для удаления используется удаление 
     * субъекта и объекта с ипользованием прокси сервис в Liferay */
    delete: (iri, graph) => dispatch => {
        DeleteSubjectRequest.setIRI(iri);
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': graph || DeleteSubjectRequest.graph,
            'query': DeleteSubjectRequest.sparql,
          }
        DeleteObjectRequest.setIRI(iri);
        const formData2 = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': graph || DeleteObjectRequest.graph,
            'query': DeleteObjectRequest.sparql,
          }
          //console.log("SkosActions.js deleteElement", formData, options);
        return Promise.all([
                LiferayApiUtils.postToLifeRay721(formData, options),
                LiferayApiUtils.postToLifeRay721(formData2, options)
            ]).then ((response) =>{
                return Promise.resolve({iri, response});
            })
            .catch(e => { 
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка при выполнении запроса ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Удалиь граф используя  CLEAR GRAPH */
    deleteGrpah: (graph) => dispatch => {
        const sparql = `CLEAR GRAPH <${graph}>`;
        const options = {...LiferaySettings.options};
        const formData = {
            'cmd': JSON.stringify({'/mpo.mpo/sparql_update':{}}),
            'default_graph_uri': graph,
            'query': sparql,
          }
        return LiferayApiUtils.postToLifeRay721(formData, options)
            .then ((response) =>{
                return Promise.resolve({graph, response});
            })
            .catch(e => {
                dispatch(DcatCatalogs.LOAD_ERROR(`Failed to delete graph: ${e}.`));
                return Promise.reject(e);
            });
    },

    /** Загрузить информацию о субъекте. subject - iri субъекта. Возвращает триплеты */
    loadSubject: (subject, graph) => {
        PredicatSubjectRequest.setIRI(subject);
        return ApiUtils.queryViaLiferay(PredicatSubjectRequest.sparql, graph)
            .then ((response) =>{
                const {head, results} = response;
                const {distinct, ordered, bindings} = results;
                return Promise.resolve({subject, graph, head, distinct, ordered, bindings});
            });
    }, 


    /** Получить все именованные субъекты графа для последовательного удаления. */
    loadGraphSubjects: (graph) => dispatch => {
        dispatch(DcatCatalogs.LOAD_STARTED());
        const sparql = "SELECT DISTINCT ?subject WHERE { ?subject ?predicate ?object . FILTER(isIRI(?subject)) }";
        return ApiUtils.queryViaLiferay(sparql, graph)
            .then(response => (response.results?.bindings || [])
                .map(item => item.subject?.value)
                .filter(Boolean))
            .catch(e => {
                dispatch(DcatCatalogs.LOAD_ERROR(`Ошибка получения объектов графа: ${e}.`));
                return Promise.reject(e);
            });
    }
};
